// extracted by mini-css-extract-plugin
module.exports = {"swiper":"product-carousel-swiper_swiper__Z7z7b","slide":"product-carousel-swiper_slide__AYO_c"};